export const toTurkishProperCase = (str, locale = "tr-TR") => {
    if (!str) return "";
    const localeInfos = {
        "tr-tr": {
            lower: {i: "İ", ı: "I", ş: "Ş", ğ: "Ğ", ü: "Ü", ç: "Ç", ö: "Ö"},
            upper: {İ: "i", I: "ı", Ş: "ş", Ğ: "ğ", Ü: "ü", Ç: "ç", Ö: "ö"}
        }
    };
    let localeInfo;
    // helper vars
    const mask = "\\s:\\-"; // add additional delimeters chars to the mask if needed
    const rg = new RegExp("([^" + mask + "])([^" + mask + "]*)", "g");
    const fnToLocaleLower = function(s) {
        return localeInfo.upper[s];
    };
    const fnToProper = function($0, $1, $2) {
        if (localeInfo) {
            if (localeInfo.lower.hasOwnProperty($1)) $1 = localeInfo.lower[$1];
            $2 = $2.replace(localeInfo.upperSearchRegExp, fnToLocaleLower);
        }
        return $1.toUpperCase() + $2.toLowerCase();
    };
    // helper calculations
    const localeInfosKeys = Object.keys(localeInfos);
    for (let i = 0; (localeInfo = localeInfos[localeInfosKeys[i]]); i++) {
        localeInfo.lowerSearchRegExp = new RegExp(
            "[" + Object.keys(localeInfo.lower).join("") + "]",
            "g"
        );
        localeInfo.upperSearchRegExp = new RegExp(
            "[" + Object.keys(localeInfo.upper).join("") + "]",
            "g"
        );
    }
    localeInfo = localeInfos[locale.toLowerCase() || null];
    return str.replace(rg, fnToProper);
};
